import {
    AppliedBillableConceptEntityType,
    HierarchicalBillingCaseTreeResponse,
    HierarchicalBillingPortionTreeResponse,
    HierarchicalBillingSampleTreeResponse,
    HierarchicalBillingSubportionTreeResponse
} from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { LiquorTreeNodeStructure, LiquorTreeOptions } from 'liquor-tree'

export interface ValuableConceptsTreeNode {
    id: number
    entityType: AppliedBillableConceptEntityType
    label: string
    fullLabel: string
    icon: string
    value: number
    entityTypeLabel: string
    caseId?: number
    sampleId?: number
    portionId?: number
    subportionId?: number
}

export type ValuableConceptsTreeEntities =
    HierarchicalBillingCaseTreeResponse |
    HierarchicalBillingSampleTreeResponse |
    HierarchicalBillingPortionTreeResponse |
    HierarchicalBillingSubportionTreeResponse

export type ValuableConceptsTreeNodeStructure = LiquorTreeNodeStructure<ValuableConceptsTreeNode, ValuableConceptsTreeNodeStructure>

export interface ValuableConceptsModalTreeState {
    data: StrictNullable<ValuableConceptsTreeNodeStructure>
    promise: StrictNullable<Promise<void>>
    treeOptions: LiquorTreeOptions
}
export const initialValuableConceptsModalTreeState =
    (): ValuableConceptsModalTreeState => ({
        data: null,
        promise: null,
        treeOptions: {
            checkbox: false,
            autoCheckChildren: false,
            parentSelect: true
        }
    })
